export class CompanyAddrssDataDto {
  address?: string;
  addressDetail?: string;
}
